import React from 'react';

const SVG = ({ style = {}, fill = '#000', width = 100, className = '', viewBox = '0 0 36 30' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox={viewBox}
    className={`svg-icon ${className || ''}`}
  >
    <defs>
      <path
        id="w"
        d="M18.89 17.512a.849.849 0 0 0-.85-.845h-5.713a.846.846 0 0 0-.85.845V25H0V0h34v25H18.89z"
      />
      <path
        id="y"
        d="M.324 10.657L11.12.509l10.797 10.148h-1.385a1.7 1.7 0 0 1 1.708 1.704v10.263c0 .94-.765 1.703-1.708 1.703H1.708A1.7 1.7 0 0 1 0 22.624V12.36c0-.941.766-1.704 1.708-1.704H.324z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-4h36v36H-1z" />
      <g>
        <mask id="x" fill="#fff">
          <use xlinkHref="#w" />
        </mask>
        <g mask="url(#x)">
          <g transform="translate(4.063 .474)">
            <mask id="z" fill="#fff">
              <use xlinkHref="#y" />
            </mask>
            <use fill="#FF694B" xlinkHref="#y" />
            <path
              fill="#000"
              d="M11.492 2.313a.936.936 0 0 0-1.243 0l-13.19 12.106a.761.761 0 0 0 0 1.141c.344.315.9.315 1.244 0L10.871 4.024 23.438 15.56a.917.917 0 0 0 .622.237c.225 0 .45-.079.621-.237a.76.76 0 0 0 0-1.141L11.492 2.313z"
              mask="url(#z)"
              opacity=".2"
            />
          </g>
          <rect width="3.707" height="3.403" x="13.33" y="9.831" fill="#FFC120" rx=".85" />
          <path
            fill="#D2B7B1"
            d="M15.588.757a.986.986 0 0 0-1.31 0L.377 13.517a.802.802 0 0 0 0 1.202.986.986 0 0 0 1.31 0L14.933 2.561 28.18 14.719c.181.166.418.25.655.25a.967.967 0 0 0 .655-.25.802.802 0 0 0 0-1.203L15.59.756z"
          />
          <path
            fill="#97C874"
            d="M23.005 24.837v-.043c-1.058-.197-1.854-1.055-1.854-2.084 0-1.054.836-1.929 1.932-2.097.346-1.475 1.775-2.581 3.485-2.581 1.75 0 3.205 1.158 3.506 2.685.25-.086.523-.133.808-.133 1.28 0 2.317.952 2.317 2.126 0 1.175-1.037 2.127-2.317 2.127-.159 0-.314-.015-.464-.043v.043h-7.413z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SVG;
